import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { AuthAccessProvider } from '../core/core.auth';
import { UserContext, BaseComponent, Presence, ExitCause, User, EnterCause } from '../core/core.component';
import { MessageProvider } from '../service/message.service';
import { PresenzeService } from '../service/presenze.service';
import { UserService } from '../service/user.service';
import { AppConstants } from '../core/app.constants';
import {SelectItem} from 'primeng/primeng';
import { Observable } from 'rxjs';

declare var $: any;

@Component({
  selector: 'app-detail-presence',
  templateUrl: './detail-presence.component.html',
  styleUrls: ['./detail-presence.component.css'],
  host: { '(window:keydown)': 'shortcutHandler($event)' }
})
export class DetailPresenceComponent extends BaseComponent implements OnInit
{
    static DIALOG_ID: string = "detailPresenceDialog";
    title: string = "";
    @Output() completeAction = new EventEmitter<number>();
    
    userContext: UserContext = null
    it: any = AppConstants.ITA_CALENDAR_CONF;
    presenceDate: Date = null;
    enterHours: string = null;
    exitHours: string = null;
    presence: Presence = null;
    enterCauses: SelectItem[] = [];
    enterCauseSelected: string;
    exitCauses: SelectItem[] = [];
    exitCauseSelected: string;
    errorMessage: string;
    completed: boolean = true;
    isUserAdmin: boolean = false;
    userSelected: SelectItem = null;
    filterUsers: SelectItem[] = [];
    filteredUsers: SelectItem[] = [];
    users: User[] = [];
    mode: string = "";
    
    constructor(protected authAccess: AuthAccessProvider, 
            protected router: Router,
            protected messageProvider: MessageProvider, 
            private presenzeService: PresenzeService,
            private userService: UserService,
            private datePipe: DatePipe)  
    {
        super(authAccess, router, messageProvider);
    }

  ngOnInit() 
  {
      this.userContext = this.authAccess.getUserContext();
      if(this.userContext == null) {    
          this.authAccess.invalidate();
      } 
      else {
          this.init();
          this.presenzeService.getDetailStatus().
               subscribe(presence => 
               {
                   if(presence != null)
                   { 
                       this.title = (presence.id == null ? "Inserimento " : "Modifica ") + "Presenza";
                       this.mode = presence.id == null ? "I" : "M";
                       $("#" + DetailPresenceComponent.DIALOG_ID).modal({backdrop: 'static', keyboard: false});
                       
                       this.presence = presence;
                       this.presenceDate =  new Date();
                       if(presence.begin != null) {
                           this.presenceDate = new Date(presence.begin);
                       }
                       this.enterHours = this.datePipe.transform(this.presenceDate, "HH:mm"); 
                       if(presence.end != null) {
                           this.exitHours = this.datePipe.transform(presence.end, "HH:mm"); 
                       }
                       if(this.presence.idMotivUsc != null) {
                           this.exitCauseSelected = (this.presence.idMotivUsc+"");
                       }
                       if(this.isUserAdmin && this.mode=="M") {
                           for(let i = 0; i < this.filterUsers.length; ++i) {
                               if(this.filterUsers[i].value == presence.userId) {
                                   this.userSelected = this.filterUsers[i];
                                   break;
                               }
                           }
                           this.getEnterCauses(presence.userId);
                       } else {
                           this.getEnterCauses();
                       }
                   } else {
                       this.close();
                   }
               });
      }
  }
  
  getEnterCauses(userId?:number) {
    this.enterCauses = [];
    this.enterCauseSelected = null;
    this.presenzeService.getEnterCauses(this.userContext.srmToken, userId).subscribe(
        result => {
            var enterCauses = result.enterCauses;
            for(var i = 0; i < enterCauses.length; ++i) {
                var current: EnterCause = enterCauses[i];
                this.enterCauses.push({label: current.description, value: current.id+""});
            }
            if (enterCauses.length == 1) {
                this.enterCauseSelected = enterCauses[0].id + "";
            } else if (this.presence != null && this.presence.idMotivEnt != null) {
                this.enterCauseSelected = this.presence.idMotivEnt + "";
            }
        },
        error => {
            this.handleError(error);
    });
  }
  
  filterUser(event) 
  {
      this.filteredUsers = AppConstants.filterSuggestions(this.filterUsers, event.query, item => [item.label]);
  }
  
  resetExit()
  {
      this.exitHours = null;
      this.exitCauseSelected = this.exitCauses[0].value;
  }
  
  storePresence()
  {
      if(this.enterHours == null || this.enterHours.trim() == "") {
          this.errorMessage = "Indicare l'orario di ingresso";
          return;
      }
      if(this.enterCauseSelected == "" || this.enterCauseSelected == null) {
          this.errorMessage = "Indicare la motivazione di ingresso";
          return;
      }   
      if(this.exitHours != null && this.exitHours.trim() != "" && 
           (this.exitCauseSelected == "" || this.exitCauseSelected == null)) {
          this.errorMessage = "Indicare la motivazione di uscita";
          return;
      }
      if(this.exitCauseSelected != null && this.exitCauseSelected.trim() != "" && 
             (this.exitHours == null || this.exitHours.trim() == "")) {
          this.errorMessage = "Indicare l'orario di uscita";
          return;
      }
      
      if(this.presence.id == null) {
          this.insertPresence();
      } else {
          this.updatePresence();
      }
  }
  
  // metodi duplicati -> non funziona con il passaggio per copia
  
  checkHourEnter()
  {
      if(this.enterHours == null || this.enterHours.trim() == "") {
          return;
      }
      let index = this.enterHours.lastIndexOf(":");
      if(index > 0) {
         let tmp: string[] = this.enterHours.split(":");
         let hh = Number(tmp[0]);
         let mm = Number(tmp[1]);
       
         if(hh > 23 || mm > 59) {
             this.enterHours = null;
         }
      }
  }
  checkHourExit()
  {
      if(this.exitHours == null || this.exitHours.trim() == "") {
          return;
      }
      let index = this.exitHours.lastIndexOf(":");
      if(index > 0) {
         let tmp: string[] = this.exitHours.split(":");
         let hh = Number(tmp[0]);
         let mm = Number(tmp[1]);
       
         if(hh > 23 || mm > 59) {
             this.exitHours = null;
         }
      }
  }
  
  private insertPresence()
  {
      let _presence: Presence = new Presence();
      _presence.begin = this.buildDateAndHour(this.enterHours);
      _presence.end = this.buildDateAndHour(this.exitHours);
      if(this.enterCauseSelected != null && this.enterCauseSelected != "") {
        _presence.idMotivEnt = Number(this.enterCauseSelected);
    }
      if(this.exitCauseSelected != null && this.exitCauseSelected != "") {
          _presence.idMotivUsc = Number(this.exitCauseSelected);
      }
      this.completed = false;
      this.presenzeService.insertPresence(this.userContext.srmToken, 
              this.userSelected != null ? this.userSelected.value : 0, this.presenceDate, this.enterHours, 
              this.enterCauseSelected, this.exitHours, this.exitCauseSelected).subscribe(
           response => {
               this.completed = true;
               _presence = response;
               this.completeAction.emit(_presence.id);
               this.close();
           },
           error => {
               this.completed = true;
               this.errorMessage = this.retrieveError(error);
               if(this.errorMessage == null) {
                   this.close();
               }
           });     
  }
  
  private updatePresence()
  {
      this.completed = false;
      this.presenzeService.updatePresence(this.userContext.srmToken, 
        this.presence.id, this.userSelected != null ? this.userSelected.value : 0, this.presenceDate, this.enterHours,
        this.enterCauseSelected, this.exitHours, this.exitCauseSelected).subscribe(
           response => {
               this.completed = true;
               this.completeAction.emit(this.presence.id);
               this.close();
           },
           error => {
               this.completed = true;
               this.errorMessage = this.retrieveError(error);
               if(this.errorMessage == null) {
                   this.close();
               }
           });     
  }

  private buildDateAndHour(hour: string) : Date
  {
      if(hour == null || hour.trim() == "") { 
          return null;
      }
      let date = new Date();
      date.setDate(this.presenceDate.getDate());
      date.setMonth(this.presenceDate.getMonth());
      date.setFullYear(this.presenceDate.getFullYear());
     
      let index = hour.lastIndexOf(":");
      if(index > 0) {
         let tmp: string[] = hour.split(":");
         let hh = Number(tmp[0]);
         let mm = Number(tmp[1]);
         date.setHours(hh, mm, 0, 0);
      }
      return date;
  }
  
  private init()
  {
      this.exitCauses.push({label: "Nessuna", value: ""});
      let obs: Observable<any>[] = [];
      obs.push(this.presenzeService.getExitCauses(this.userContext.srmToken));
      obs.push(this.userService.isUserAdmin(this.userContext.srmToken));
      
      Observable.forkJoin(obs).subscribe(
        results => {
            var exitCauses = results[0].exitCauses;
            for(var i = 0; i < exitCauses.length; ++i) {
                var current: ExitCause = exitCauses[i];
                this.exitCauses.push({label: current.description, value: current.id+""});
            }
            this.isUserAdmin = results[1].message == "true";
            if(this.isUserAdmin) 
            {
                this.userService.getUsers(this.userContext.srmToken).subscribe(
                    result => {
                        this.users = result.users;
                        for(var i = 0; i <  result.users.length; ++i) {
                            var current: User =  result.users[i];
                            this.filterUsers.push({label:current.fullname, value: current.id});
                        }
                    },
                    error => {
                        this.handleError(error);
                        this.close();
                    }
                );
            }
        },
        error => {
            this.handleError(error);
            this.close();
        });
  }
  
  close()
  {
      $("#" + DetailPresenceComponent.DIALOG_ID).modal("hide");
      this.mode = "";
      this.presence = null;
      this.presenceDate = null;
      this.enterHours = null;
      this.enterCauseSelected = null;
      this.exitHours = null;
      this.exitCauseSelected = null;
      this.userSelected = null;
      this.errorMessage = null;
  }
    
  shortcutHandler(event) { 
    if (event.keyCode == 27) { // ESC
       this.close();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/detail-presence/detail-presence.component.ts